import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigation } from '@react-navigation/native';

const NavigationGuard = ({ children }) => {
  const navigation = useNavigation();
  const magicLinkAuthLoading = useSelector(
    (state) => state.login.magicLinkAuthLoading
  );

  useEffect(() => {
    // Prevent navigation during magic link authentication
    if (magicLinkAuthLoading) {
      const unsubscribe = navigation.addListener('beforeRemove', (e) => {
        // Prevent the default action (navigation)
        e.preventDefault();
      });

      return () => {
        unsubscribe();
      };
    }
  }, [magicLinkAuthLoading, navigation]);

  return children;
};

export default NavigationGuard; 